import { makeStyles, tokens, Title2 } from '@fluentui/react-components';
import React from 'react';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        backgroundColor: tokens.colorNeutralBackground3,
        boxShadow: 'rgb(0 0 0 / 25%) 0 0.2rem 0.4rem -0.075rem',
    },
    content: {
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        height: '100%',
        overflow: 'hidden',
        padding: `${tokens.spacingVerticalL} ${tokens.spacingHorizontalL}`,
    },
    title: {
        marginBottom: tokens.spacingVerticalL,
    },
});

export const HistoryView: React.FC = () => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <Title2 className={classes.title}>History</Title2>
            </div>
        </div>
    );
};
